import { now } from 'lodash';

const scrollElementIntoView = (element) => {
  const rect = element.getBoundingClientRect();

  if (rect.top < 0 || rect.top > window.innerHeight) {
    element.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
};

const finishScroll = (destination, callBack) => {
  window.scrollTo(0, destination);

  callBack();
};

const calcScrollPos = (timeElapsed, start, distance, duration) => {
  const t = timeElapsed / duration;

  return (t * (2 - t) * distance) + start;
};

const scrollToElement = (element, duration, callBack) => {
  const startTime = now();
  const start = window.pageYOffset;
  const distance = element.getBoundingClientRect().top;
  const destination = start + distance;
  let timeElapsed = 0;

  const scrollLoop = () => {
    timeElapsed = now() - startTime;

    window.scrollTo(0, calcScrollPos(timeElapsed, start, distance, duration));

    return timeElapsed < duration
      ? window.requestAnimationFrame(scrollLoop)
      : finishScroll(destination, callBack);
  };

  scrollLoop();
};

export default { scrollElementIntoView, scrollToElement };



/** WEBPACK FOOTER **
 ** ./src/common/DomUtilities.js
 **/